export const QUERY__KYC = 'kyc';
